import { createStorageAtomFactory } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';

import type { Storage } from '@/background/adapters/storage';

type Dependencies = {
  storage: Storage;
};

export const INSTALL_CALLOUT_STORAGE_KEY = 'installCalloutVisible';

const createInstallCalloutVisibleAtom = ({ storage }: Dependencies) => {
  const createAtom = createStorageAtomFactory<boolean>({ storage });

  return createAtom({
    key: INSTALL_CALLOUT_STORAGE_KEY,
    defaultValue: false,
  });
};

export type InstallCalloutVisibleAtom = ReturnType<
  typeof createInstallCalloutVisibleAtom
>;

const installCalloutVisibleAtomDefinition = {
  id: 'installCalloutVisibleAtom',
  type: 'atom',
  factory: createInstallCalloutVisibleAtom,
  dependencies: ['storage'],
} as const satisfies Definition;

export default installCalloutVisibleAtomDefinition;
